const titleIcon = "h-5 w-5 text-primary shrink-0";

const headerTitle = "text-lg sm:text-xl font-bold text-foreground tracking-tight";

const backBtn = "shrink-0";

const clearBtn = "shrink-0 text-muted-foreground hover:text-foreground";

export { titleIcon, headerTitle, backBtn, clearBtn };
